import React, { useCallback, useEffect, useState } from 'react';
import AppLayout from '../../../../../component/appLayout';
import MembersNavbar from '../navBar';
import { useParams } from 'react-router-dom';
import TasksDataV2 from '../../../../../component/tasks';
import { captureException } from '../../../../../services/logService';
import { MY_TASKS_GROUP_FILTER_TYPE } from '../../../../../global/constants';
import { getUserWorkspacePreferenceData } from '../../../../../helpers/firebaseHelper';
import { isEmpty } from '../../../../../helpers/common';
import { rootStore } from '../../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';

const Tasks: React.FC = () => {
  // States
  const [loading, setLoading] = useState(false);

  //Mobx store variables
  const { workspaceStore, taskStore } = rootStore;
  const { currentWorkspace } = workspaceStore;

  // Other variables
  const params: { id: string } = useParams();

  // load initial data
  const loadData = useCallback(async () => {
    try {
      if (!isEmpty(currentWorkspace?.id)) {
        setLoading(true);
        // Get my task filter from user preference
        const userFilter = await getUserWorkspacePreferenceData('my_task_filter');
        taskStore.setMyTasksFilter(userFilter?.group_by ?? MY_TASKS_GROUP_FILTER_TYPE.DUE_DATE);
      }
    } catch (e) {
      captureException(e);
    } finally {
      setLoading(false);
    }
  }, [currentWorkspace?.id, taskStore]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <>
      <AppLayout>
        <MembersNavbar
          loadData={loadData}
          membersTask={currentWorkspace?.users.find((user) => user.id === params?.id)?.filteredTasks || []}
        />
        <TasksDataV2
          data={currentWorkspace?.users.find((user) => user.id === params?.id)?.filteredTasks || []}
          loading={loading}
          loadData={loadData}
          isMember={true}
          memberId={params?.id}
        />
      </AppLayout>
    </>
  );
};

export default observer(Tasks);
